import { pluralize } from "./stringUtils";

const getMessageForPeoples = (peoples: number[], peoplesTypeName: string) => {
  return (
    <>
      All users in <b>{peoples.length}</b> {pluralize(peoplesTypeName, peoples.length)}
    </>
  );
};

const getSectionForUser = (selectedUserIds: number[], defaultStr: string = "") => {
  return (
    <li>
      {defaultStr} <b>{selectedUserIds.length}</b> individual {pluralize("user", selectedUserIds.length)}
    </li>
  );
};

export const getPeopleSection = (
  selectedUserIds: number[],
  selectedGroupIds: number[],
  selectedTemplateIds?: number[],
  isThreatDefence: boolean = false,
) => {
  const usersSelected = selectedUserIds && selectedUserIds.length > 0;
  const groupsSelected = selectedGroupIds && selectedGroupIds.length > 0;
  const templatesSelected = selectedTemplateIds && selectedTemplateIds.length > 0;
  const templateWarning = isThreatDefence
    ? " (campaign will be sent only to the customers that have enabled the Microsoft Graph and approved the template)"
    : null;

  if (usersSelected && groupsSelected && templatesSelected) {
    return (
      <>
        <li>
          {getMessageForPeoples(selectedTemplateIds, "template")}
          {templateWarning}, and <b>{selectedGroupIds.length}</b> {pluralize("group", selectedGroupIds.length)}
        </li>
        {getSectionForUser(selectedUserIds, "And")}
      </>
    );
  }
  if (usersSelected && groupsSelected) {
    return (
      <>
        <li>{getMessageForPeoples(selectedGroupIds, "group")}</li>
        {getSectionForUser(selectedUserIds)}
      </>
    );
  }
  if (groupsSelected && templatesSelected) {
    return (
      <>
        <li>
          {getMessageForPeoples(selectedTemplateIds, "template")}
          {templateWarning}, and <b>{selectedGroupIds.length}</b> {pluralize("group", selectedGroupIds.length)}
        </li>
      </>
    );
  }
  if (usersSelected && templatesSelected) {
    return (
      <>
        <li>
          {getMessageForPeoples(selectedTemplateIds, "template")}
          {templateWarning}
        </li>
        {getSectionForUser(selectedUserIds)}
      </>
    );
  }
  if (usersSelected) return <>{getSectionForUser(selectedUserIds)}</>;
  if (groupsSelected) return <li>{getMessageForPeoples(selectedGroupIds, "group")}</li>;
  if (templatesSelected)
    return (
      <li>
        {getMessageForPeoples(selectedTemplateIds, "template")}
        {templateWarning}
      </li>
    );
  return <></>;
};
